import { module } from 'modujs'

export default class extends module {
    constructor(m) {
        super(m)

        // UI
        this.$el = this.el

        this.sources = JSON.parse(this.getData('sources'))
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        const randomIndex = this.randomIntFromInterval(0, this.sources.length)
        const selectedSource = this.sources[randomIndex]
        this.computeVideoSource(selectedSource)
    }

    destroy() {
        super.destroy()
    }

    ///////////////
    // Methods
    ///////////////
    computeVideoSource(source) {
        this.$el.src = source
    }

    randomIntFromInterval(min, max) {
        return Math.floor(Math.random() * (max - min) + min)
    }
}
